import * as React from 'react';
import { useEffect, useState } from 'react';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { routes } from 'src/navigation';
import styles from '../../../assets/case-component-tab.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlusCircle,
    faCheckCircle,
    faLongArrowAltLeft,
    faLongArrowAltRight,
    faAngleDoubleLeft,
    faAngleDoubleRight, faSave,
} from '@fortawesome/free-solid-svg-icons';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Paginated } from 'src/services/api-handlers/pagination';
import { ISeance } from 'src/types/seance';
import { ICase } from 'src/types/case';
import { groupInvoiceToCsv } from 'src/helpers/seance/groupSeanceCsv';
import groupModal from '../helpers/groupModal';
import ModalComponent from './ModalComponent';
import { useDispatch, useSelector } from 'react-redux';
import { QueryParams } from 'src/types/grid';
import { getRowsSession, getRowsSessionManual } from '../helpers/index';

import user from '../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';
import { IProvider } from '../../../../../../../../../types/provider';
import Router from '../../../../../../../../../navigation/router';
import { StoreState } from '../../../../../../../../../store/reducers';
import { getSeancesList } from '../../../../../../../../../store/actions/seance-actions';
import moment from 'moment';
import { DateTimePicker } from 'react-widgets';
import OrderEnum from '../../../../../../../../../enumerables/order-enum';
import { getValFromEnum } from '../../../../../../../../../components/redux-form/utils/dropdown-values';
import { CaseApi } from '../../../../../../../../../services/end-points';
import { Button, Modal } from 'react-bootstrap';

interface RouteParams {
    id: string;
    subId: string;
}

export interface Props extends RouteComponentProps<RouteParams> {
    data: Paginated<ISeance>;
    provider: Partial<IProvider> | null;
    caseCurrent: ICase | null;
    statusEnum: any;
    inProgressInvoice: boolean;
    month: { monthEnd: string; monthStart: string };
    updateSeance: (status: number, id: string, setPopup: (param: boolean) => void) => void;
    cases: Paginated<ICase>;
    seances: Paginated<ISeance>;
    seancesList: Paginated<ISeance>;
    serviceTypes: SelectObject[];
    serviceLocations: SelectObject[];
    getData: (params: QueryParams) => void;
    getSeancesList: (params: QueryParams) => void;
    createInvoiceAction: (params: any, setPopup: (param: boolean) => void) => void;
    createStatementAction: (params: any, setPopup: (param: boolean) => void) => void;
}

const SessionTable: React.FunctionComponent<Props> = ({
    match: {
        params: { id },
    },
    provider,
    caseCurrent,
    cases,
    seances,
    seancesList,
    createInvoiceAction,
    createStatementAction,
    serviceLocations,
    serviceTypes,
    statusEnum,
    updateSeance,
    getData,
    getSeancesList,
    month,
    data,
}: Props) => {
    const dataProgramBooks = useSelector((state: StoreState) => state.programBooks.data);
    const dataProgramBooksInProgress = useSelector((state: StoreState) => state.programBooks.inProgress);
    const [formColumn, setFormColumn] = useState<any>(false);
    const [popup, setPopup] = useState<boolean>(false);
    const [isRate, setRatePer] = useState<boolean>(false);
    const [openDrop, setOpenDrop] = useState<boolean>(false);

    const [currentAction, setCurrentAction] = useState<string>('SIGN');
    const [manualAction, setManualAction] = useState<{} | boolean>(false);
    const [currentActionData, setCurrentActionData] = useState<any>({});

    const [start, setStart] = useState<string>('');
    const [end, setEnd] = useState<string>('');

    const dispatch = useDispatch();

    const [existData, setExistData] = useState<any>(0);
    const [dataSaveModal, setSaveModal] = useState(false);
    const [valueOrderTypeLabel, setValueOrderTypeLabel] = useState<string>('');

    const caseValues: SelectObject[] = [];

    cases.list.forEach((cas: Partial<ICase>) => {
        caseValues.push({ value: `${cas.id}`, label: `${cas.id}` });
    });

    const entityModal: any = groupModal({
        dispatch,
        currentActionData,
        setPopup,
        updateSeance,
        createInvoiceAction,
        caseCurrent,
        id,
        month,
        createStatementAction,
        setCurrentActionData,
        setCurrentAction,
        setEnd,
        setStart,
    });

    const { totalPages, page } = data;
    const canInvoice = true;
    let dataSessionComponents: any = [];

    if (Object.values(statusEnum).length) {
        if (manualAction) {
            dataSessionComponents = getRowsSessionManual(data.list, {
                id,
                caseCurrent,
                statusEnum,
                canInvoice,
                setManualAction,
                manualAction,
            });
        } else {
            const filteredData = data.list.filter((item) => item.status !== 5);
            dataSessionComponents = getRowsSession(filteredData, {
                formColumn,
                setOpenDrop,
                month,
                dispatch,
                serviceLocations,
                statusEnum,
                serviceTypes,
                setRatePer,
                isRate,
                provider,
                id,
                caseCurrent,
                canInvoice,
                setCurrentAction,
                setPopup,
                setCurrentActionData,
                caseValues,
                setFormColumn,
                existData,
                setExistData,
                dataSaveModal,
                setSaveModal,
                valueOrderTypeLabel,
                setValueOrderTypeLabel,
            });
        }
    }

    const dataAdd = [];
    if (caseCurrent?.district) {
        dataAdd.push({ id: 'seanceInfo', label: 'Student Addition', cellStyle: 'normal' });
    }

    const dataCaseArr = [];
    if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
        dataCaseArr.push({ id: 'toCase', label: 'Case', cellStyle: 'normal' });
    }

    const RatePerArr = [];
    if (isRate) {
        RatePerArr.push({ id: 'externalRatePerHour', label: 'External Rate per Hour', cellStyle: 'normal' });
        RatePerArr.push({ id: 'externalRatePerUnit', label: 'External Rate per Unit', cellStyle: 'normal' });
        RatePerArr.push({ id: 'internalRatePerHour', label: 'Internal Rate per Hour', cellStyle: 'normal' });
        RatePerArr.push({ id: 'internalRatePerUnit', label: 'Internal Rate per Unit', cellStyle: 'normal' });
        RatePerArr.push({ id: 'totalUnit', label: 'Total Units', cellStyle: 'normal' });
        RatePerArr.push({ id: 'totalFee', label: 'Total Fee', cellStyle: 'normal' });
    }
    const isProvider =
        !user.getRoles().includes(UserRole.ROLE_ADMIN) && provider?.userProviders && !provider.userProviders.length;
    const signArr = [];
    if (!isProvider) {
        // signArr.push({ id: 'signDoc', label: 'Sign Doc', cellStyle: 'normal' });
    }

    signArr.push({ id: 'signDoc', label: 'Sign Doc', cellStyle: 'normal' });

    useEffect(() => {
        dispatch(
            getSeancesList({
                page: 1,
                filters: {
                    'occasion.id': caseCurrent?.id,
                    'provider.id': id,
                    'seanceDate[after]': start,
                    'seanceDate[before]': end,
                },
                itemsPerPage: 1200,
            }),
        );

        // eslint-disable-next-line
    }, [start, end]);

    useEffect(() => {
        setCurrentActionData({
            ...currentActionData,
            seancesList: seancesList,
        });

        // eslint-disable-next-line
    }, [seancesList]);

    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);
    useEffect(() => {
        if (existData?.length) {
            const valueOrderType = orderTypes.find((it) => it.value === existData[0].orderType);
            setValueOrderTypeLabel(valueOrderType ? valueOrderType.label : '');
        }
        // eslint-disable-next-line
    }, [existData]);

    const handleAddSession = () => {
        setFormColumn(true);
        if (caseCurrent?.id) {
            const result = CaseApi.getCase(caseCurrent?.id).then(async (response) => {
                if (
                    response?.data &&
                    response?.data?.caseType == 1 &&
                    (response?.data?.orderType == 2 || response?.data?.orderType == 3)
                ) {
                    const result = CaseApi.getCases({
                        'orderEntity.caseNumber': response?.data?.caseNumber,
                        caseType: 1,
                        onlyActive: 1,
                        orderType: [1, 6],
                        'student.id': response?.data?.student?.id,
                        page: 1,
                        itemsPerPage: 1,
                        pagination: 1,
                    }).then(async (response2) => {
                        //show the modal
                        setExistData(response2?.data?.length ? response2?.data : 0);
                        //setIsEnableCreate(true);
                    });
                } else {
                    //setIsEnableCreate(true);
                    setExistData(0);
                }
            });
        }
    };

    return (
        <div className={'d-flex flex-column'}>
            {/*       {!dataSessionComponents.length ? <Loader /> : null}*/}
            <div style={openDrop ? { overflow: 'visible' } : {}} className={'responsive-table'}>
                {manualAction ? (
                    <button
                        className={classNames(styles.buttonColumn, styles.buttonColumnInv, styles.backBtn, 'mb-3')}
                        type={'button'}
                        onClick={() => setManualAction(false)}
                    >
                        <FontAwesomeIcon className={'mr-1'} icon={faLongArrowAltLeft} /> <div>back</div>
                    </button>
                ) : (
                    ''
                )}

                <SimpleTable
                    key={dataSessionComponents.length + 'session'}
                    action={setFormColumn}
                    data={dataSessionComponents}
                    getData={(data) => {
                        getData({
                            filters: {
                                'occasion.id': caseCurrent?.id,
                                'provider.id': id,
                            },
                            ...data,
                        });
                    }}
                    pagination={{ page, totalPages }}
                    columns={[
                        { id: 'action', label: 'Action', cellStyle: 'normal' },
                        { id: 'id', label: 'Note ID', cellStyle: 'normal' },
                        ...dataCaseArr,
                        { id: 'status', label: 'Status', cellStyle: 'normal' },
                        { id: 'serviceType', label: 'Service Type', cellStyle: 'normal' },
                        { id: 'serviceLocation', label: 'Service Location', cellStyle: 'normal' },
                        { id: 'minPerUnit', label: 'Min Per Unit', cellStyle: 'normal' },
                        ...dataAdd,
                        { id: 'seanceDate', label: 'Session Date', cellStyle: 'miw100' },
                        { id: 'startTime', label: 'Start Time', cellStyle: 'miw80' },
                        { id: 'endTime', label: 'End Time', cellStyle: 'miw80' },
                        { id: 'datasheet', label: 'PBook', cellStyle: 'miw80' },
                        ...signArr,
                        ...RatePerArr,
                        {
                            id: 'rate',
                            label: (
                                <FontAwesomeIcon
                                    onClick={() => {
                                        setRatePer(!isRate);
                                    }}
                                    icon={isRate ? faAngleDoubleLeft : faAngleDoubleRight}
                                />
                            ),
                            cellStyle: 'btnCell',
                        },
                    ]}
                />

                <ModalComponent
                    modal={popup}
                    setModal={setPopup}
                    dataBody={entityModal[currentAction]?.body}
                    action={entityModal[currentAction]?.action}
                />
                <div className={'d-flex justify-content-between'}>
                    <div className={'d-flex'}>
                        <div>
                            {dataProgramBooks.list.length ? (
                                <Link
                                    to={Router.generate(routes.PROGRAM_BOOK_DETAIL, {
                                        id: dataProgramBooks.list[0].id,
                                    })}
                                    type={'button'}
                                    className={'btn btn-outline-info mr-2'}
                                    target={'_blank'}
                                >
                                    Program Book Results
                                </Link>
                            ) : null}
                            {!dataProgramBooksInProgress ? (
                                dataProgramBooks.list.length ? (
                                    <Link
                                        to={Router.generate(routes.PROGRAM_BOOK_EDIT, {
                                            id: dataProgramBooks.list[0].id,
                                        })}
                                        type={'button'}
                                        className={'btn btn-outline-info mr-2'}
                                    >
                                        Edit Program Book
                                    </Link>
                                ) : (
                                    <Link
                                        to={Router.generate(routes.PROGRAM_BOOK_CREATE, {
                                            id: caseCurrent?.orderEntity?.student?.id
                                                ? caseCurrent?.orderEntity?.student?.id
                                                : caseCurrent?.student?.id,
                                        })}
                                        type={'button'}
                                        className={'btn btn-outline-info mr-2'}
                                    >
                                        Edit Program Book
                                    </Link>
                                )
                            ) : null}
                        </div>

                        {data.list.length ? (
                            isProvider ? null : (
                                <button
                                    type={'button'}
                                    className={'btn btn-outline-info'}
                                    onClick={() => {
                                        groupInvoiceToCsv(data.list);
                                    }}
                                >
                                    Export .csv
                                </button>
                            )
                        ) : null}
                    </div>

                    {!manualAction ? (
                        <div className={'d-flex justify-content-end'}>
                            {canInvoice && data.list.length ? (
                                <div>
                                    {caseCurrent && +caseCurrent?.caseType === 2 ? (
                                        <div className={'d-flex'}>
                                            {user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                                                <button
                                                    className={classNames(
                                                        styles.btnFlex,
                                                        'btn ml-2 btn-outline-info mr-2',
                                                    )}
                                                    type={'button'}
                                                    onClick={() => {
                                                        setCurrentAction('STATEMENT_DONE');
                                                        setPopup(true);
                                                        setCurrentActionData({
                                                            seanceDateFrom: month.monthStart,
                                                            seanceDateTo: month.monthEnd,
                                                        });
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faCheckCircle} /> <div>Statement</div>
                                                </button>
                                            ) : null}
                                            <button
                                                className={classNames(styles.btnFlex, 'btn ml-2 btn-outline-info mr-2')}
                                                type={'button'}
                                                onClick={() => {
                                                    const start = currentActionData
                                                        ? moment(month.monthStart)
                                                              .startOf('day')
                                                              .format('YYYY-MM-DD HH:mm:ss')
                                                        : '';
                                                    const end = currentActionData
                                                        ? moment(month.monthEnd)
                                                              .endOf('day')
                                                              .format('YYYY-MM-DD HH:mm:ss')
                                                        : '';

                                                    dispatch(
                                                        getSeancesList({
                                                            page: 1,
                                                            filters: {
                                                                'occasion.id': caseCurrent?.id,
                                                                'provider.id': id,
                                                                'seanceDate[after]': start,
                                                                'seanceDate[before]': end,
                                                            },
                                                            itemsPerPage: 1200,
                                                        }),
                                                    );

                                                    setCurrentAction('INVOICE_DONE');
                                                    setPopup(true);
                                                    setCurrentActionData({
                                                        seanceDateFrom: month.monthStart,
                                                        seanceDateTo: month.monthEnd,
                                                        seancesList: seancesList,
                                                        isCheckedPaid: true,
                                                    });
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faCheckCircle} /> <div>Invoice</div>
                                            </button>
                                        </div>
                                    ) : (
                                        <button
                                            className={classNames(styles.btnFlex, 'btn ml-2 btn-outline-info mr-2')}
                                            type={'button'}
                                            onClick={() => {
                                                setCurrentAction('INVOICE');
                                                setPopup(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faCheckCircle} /> <div>Invoice</div>
                                        </button>
                                    )}
                                </div>
                            ) : null}
                            {user.getRoles().includes(UserRole.ROLE_ADMIN) && (
                                <button
                                    className={classNames(styles.btnFlex, 'btn ml-2 btn-outline-info mr-2')}
                                    type={'button'}
                                    onClick={() => {
                                        setManualAction({});
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCheckCircle} /> <div>Invoice Manual</div>
                                </button>
                            )}

                            <button
                                className={classNames(styles.btnFlex, 'btn ml-2 btn-outline-info')}
                                type={'button'}
                                onClick={handleAddSession}
                            >
                                <FontAwesomeIcon icon={faPlusCircle} /> <div>Session</div>
                            </button>
                        </div>
                    ) : (
                        <button
                            className={classNames(styles.btnFlex, 'btn ml-2 btn-outline-info mr-2')}
                            type={'button'}
                            disabled={!!Object.keys(manualAction).length}
                            onClick={() => {
                                const arrSend: number[] = [];
                                Object.keys(manualAction).forEach((it: number | string) => {
                                    arrSend.push(+it);
                                });
                                createInvoiceAction(
                                    {
                                        id: caseCurrent?.id,
                                        providerId: +id,
                                        sessions: arrSend,
                                        seances: seances,
                                    },

                                    setManualAction,
                                );
                            }}
                        >
                            <FontAwesomeIcon icon={faLongArrowAltRight} /> <div>Invoice Manual</div>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default withRouter(SessionTable);
